import { render, staticRenderFns } from "./KodeAkun.vue?vue&type=template&id=6ebbb4a0"
import script from "./KodeAkun.vue?vue&type=script&lang=js"
export * from "./KodeAkun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports